export const APP_STATE_LOADING = "APP_STATE_LOADING";
export const APP_STATE_SET ='APP_STATE_SET'
export const APP_STATE_INCREMENT_LAST_RECEIPT_ID =
  "APP_STATE_INCREMENT_LAST_RECEIPT_ID";
export const APP_STATE_PENDING_PUSH_TRANSACTIONS =
  "APP_STATE_PENDING_PUSH_TRANSACTIONS";
